import { useContext } from 'react';
import SystemSettingsContext from '../contexts/SystemSettingsContext';

const useSystemSettingsContext = () => useContext(SystemSettingsContext);

export default useSystemSettingsContext;
